import React, { memo, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { MTableToolbar, Query } from '@material-table/core';
import { Container, MailDialog, MTable, RepealableName } from '../../../../../Components';
import { useFilter } from '../../../../../Components/ListFilter/useFilter';
import { IGridQueryRequest, OrderDirection } from '../../../../../Api/AptorApi';
import { useAptorApi } from '../../../../../Api';
import moment from 'moment';
import { Button, RadioGroup, Tooltip } from '@material-ui/core'
import { ArrowUpward, Edit, SaveAlt } from '@material-ui/icons'
import { ObservationFilter } from './Filters';
import { ComplianceReportCheckbox } from '../../../Components/Compliance/Checkbox';
import { useIsMounted } from '../../../../../Hooks/useIsMounted';
import EditObservationModal from './EditObservationModal';
import { AccessLevel, LawPortalFeature, Module, UserContext } from '../../../../../Context/UserContext/UserContext';
import { ObservationView } from './ObservationView';
import { useStyles } from '../../../LawPortal.styles';

export const Observation = () => {
  const { formatMessage } = useIntl();
  const { api, abortController } = useAptorApi();
  const tableRef = React.useRef<any>(null);
  const [filters, setFilter] = useFilter();
  const [observationPlan, setObervationPlan] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const classes = useStyles();

  const getObservationPlan = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await api.getObservationPlan({ filters });
      setObervationPlan(response.plans || []);

      // setIsDirectPlan(directPlan);
    } catch (error) {
      console.error('Error fetching report plans:', error);
      setObervationPlan([]);
    } finally {
      setIsLoading(false);
    }
  }, [api, filters]);

  useEffect(() => {
    getObservationPlan();
  }, [getObservationPlan]);
  const ObservationColumns = useMemo(() => [
    {
      title: formatMessage({ id: 'law-portal.compliance-law.plan-compliance.name-of-control' }),
      field: 'name'
    },
    {
      title: formatMessage({ id: 'law-portal.compliance-law.plan-compliance.Company-unit' }),
      field: 'companyUnit',
    },
    {
      title: formatMessage({ id: 'law-portal.compliance-law.plan-compliance.Start-date' }),
      field: 'startDate',
      render: (row: any) => moment(row?.startDate).format('YYYY-MM-DD'),
      sorting: false,
    },
    {
      title: formatMessage({ id: 'law-portal.compliance-law.plan-compliance.End-date' }),
      field: 'endDate',
      render: (row: any) => moment(row?.endDate).format('YYYY-MM-DD'),
      sorting: false,
    },
  ], [formatMessage]);

  const handleExport = async () => {
    const response = await api.ExportLawPortalLaws();
    const blob = await response?.blob();
    const contentDisposition = response.headers.get('Content-Disposition');
    let fileName = 'LawsExport.xlsx';
    if (contentDisposition && contentDisposition.includes('attachment')) {
      const matches = /filename=([^;]*)/.exec(contentDisposition);
      if (matches && matches[1]) {
        fileName = matches[1];
      }
    }
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
  };
  return (
    <>
      <ObservationFilter filters={filters} setFilter={setFilter} />
      <hr style={{ marginTop: '25px', marginBottom: "25px" }} />
      <MTable
        columns={ObservationColumns}
        data={observationPlan}
        options={{
          detailPanelColumnAlignment: 'right',
          pageSizeOptions: [10, 25, 50, 100],
        }}

        detailPanel={[
          {
            tooltip: formatMessage({ id: "text.expend" }),
            render: (rowData: any) => (
              <ObservationView PlanData={rowData?.rowData} filters={filters} />
            ),
          }
        ]}
        components={{
          Toolbar: (props) => (
            <div className={classes.toolbar}>
              <MTableToolbar {...props} />
              {/* <SaveAlt style={{ cursor: 'pointer' }} onClick={() => handleExport()} /> */}
            </div>
          ),
        }}
      />
    </>
  );
};
